// extracted by mini-css-extract-plugin
module.exports = {"badge":"WhereToBuyBadge_badge__MOan0","badge-text":"WhereToBuyBadge_badge-text__W_yvP"};